var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5001,
    r: 16.5,
    fill: "#47413D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6028 17.7767L16.9198 12.1918C16.7818 12.0911 16.6186 12.0306 16.4484 12.017C16.2781 12.0034 16.1074 12.0371 15.9551 12.1144C15.8028 12.1918 15.6749 12.3098 15.5854 12.4553C15.496 12.6009 15.4486 12.7683 15.4485 12.9391V24.1052C15.448 24.2763 15.495 24.4442 15.5843 24.5901C15.6736 24.736 15.8017 24.8543 15.9543 24.9316C16.1068 25.009 16.2779 25.0425 16.4484 25.0283C16.6189 25.0141 16.7821 24.9529 16.9198 24.8514L24.6028 19.2714C24.7215 19.1862 24.8182 19.074 24.8849 18.9441C24.9516 18.8141 24.9864 18.6701 24.9864 18.524C24.9864 18.3779 24.9516 18.2339 24.8849 18.104C24.8182 17.974 24.7215 17.8618 24.6028 17.7767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.35 18.5028C0.35 8.47676 8.47462 0.352136 18.5006 0.352136C28.5242 0.352136 36.6512 8.47679 36.65 18.5027C36.65 28.5237 28.5242 36.6472 18.5006 36.6472C8.47451 36.6472 0.35 28.5249 0.35 18.5028ZM2.74041 18.5028C2.74041 27.2077 9.79707 34.2605 18.5006 34.2605C27.2029 34.2605 34.2596 27.2077 34.2584 18.5028C34.2584 9.8005 27.2032 2.74009 18.5006 2.74009C9.79687 2.74009 2.74041 9.80169 2.74041 18.5028Z",
    fill: "white",
    stroke: "#2D2825",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.b62f4b1fa65ac89075960dc8358ebc31.svg";
export { ForwardRef as ReactComponent };